import { BaseService } from './_BaseService';

export class ReferralService extends BaseService {

    batchSave = async (referrer, referrals) => {
        return await this.post(`installers/batch-save-referrals`, { referrer, referrals });
    }
    
}